import { css } from "@emotion/css";
import { Colors, FontSizeInPx, FontWeight, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

export const detailsControl = css`
    padding-bottom: ${Spacing.MD}px;
    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: ${LineHeightInPx.REGULAR}px;
`;

export const detailsSeparator = css`
    height: 1px;
    margin: 0 0 ${Spacing.MD}px;
    background: ${Colors.Gray.V100};
    border: 0;
`;

export const detailsControlGap = css`
    display: flex;
    flex-direction: column;
    gap: ${Spacing.SM}px;
`;
